export default __webpack_public_path__ + "static/media/banner1.cb298c7a.jpg";